import React from 'react';
interface CategoryChipsProps {
  categories: string[];
  selected: string;
  onSelect: (category: string) => void;
}
export function CategoryChips({
  categories,
  selected,
  onSelect
}: CategoryChipsProps) {
  return <div className="overflow-x-auto scrollbar-hide px-4 py-3 bg-white border-b border-gray-200" data-id="element-31">
      <div className="flex gap-2 max-w-lg mx-auto" data-id="element-32">
        {categories.map(category => <button key={category} onClick={() => onSelect(category)} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${selected === category ? 'bg-green-500 text-white shadow-md' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-33">
            {category}
          </button>)}
      </div>
    </div>;
}